import { createSlice } from '@reduxjs/toolkit';
import { PartialUserStateSchema, } from '../../models/zod/user';
// Redux slices usually export a type representing their slice of data.  Since we are using zod for
// this slice to do both type creation and data validation, we're going to re-export the type here
// for convienence.
import merge from 'deepmerge';
const userPlanInitialState = {
    selectionStatus: undefined,
    seenPlanExp: undefined,
};
const userPlanCoverDepsInitialState = {
    ...userPlanInitialState,
    coverKidsNum: undefined,
    coverSpouse: undefined,
    coveredMembersDisplayText: undefined,
    eligibleKidsNum: undefined,
    hasEligibleSignificantOther: undefined,
    Election: undefined,
};
export const userInitialState = {
    Global: {
        age: undefined,
        dependents: [],
        spouseType: 'None',
        numKids: 0,
        expectsMaternity: undefined,
        fromMedToTax: 0,
        SeenOpening: {
            hospitalIndemnity: undefined,
        },
    },
    HI: {
        ...userPlanCoverDepsInitialState,
        wantsCoverage: undefined,
    },
    cancer: {
        ...userPlanCoverDepsInitialState,
    },
    pet: {
        ...userPlanInitialState,
    },
    parabolaModel: {
        eligibleModules: [],
        completedModules: [],
        storybookModules: {
            hospital: 'Hospital Indemnity',
            cancer: 'Cancer Insurance',
        },
    },
};
const userSlice = createSlice({
    name: 'user',
    initialState: userInitialState,
    reducers: {
        /**
         * Accepts a partial version of the user model and validates it to ensure it matches the known
         * schema of the User model.
         * In either case here we're deep merging the update into the redux state so we don't blow away
         * existing data, which can cause rendering errors.
         */
        update(state, action) {
            const updatedState = PartialUserStateSchema.parse(action.payload);
            merge(state, updatedState);
        },
        updateUserStateFromKentico(state, action) {
            const updatedState = PartialUserStateSchema.parse(action.payload);
            merge(state, updatedState);
        },
    },
});
export default userSlice.reducer;
export const { updateUserStateFromKentico, update: updateUserState } = userSlice.actions;
export const userAgeSelector = (state) => state.user.Global.age;
export const userSelector = (state) => state.user;
//# sourceMappingURL=user.js.map